var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#feb730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M348.816,281.643c.647,1.676.671,7.792-.082,9.411a2.066,2.066,0,0,1-.961.969c-1.143.6-12.921.594-14.424.1a2.064,2.064,0,0,1-1.364-1.323c-.595-1.626-.77-8.428.366-9.768a2.226,2.226,0,0,1,1.487-.787c3.072-.333,12.547-.286,13.637.11A2.119,2.119,0,0,1,348.816,281.643Zm-5.075,4.429c-1.854-.967-3.678-1.923-5.519-2.886v5.748C340.063,287.976,341.895,287.027,343.741,286.071Z",
    transform: "translate(-331.518 -280.022)",
    fill: "#feb730"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ab4843fe9b550b3588eb7bb4ca49a414.svg";
export { ForwardRef as ReactComponent };